import { useAuthStore } from "../../store/auth.store";
import { useEffect, useState } from "react";
import { useBreadcrumbsStore } from "../../store/breadcrumbs.store";
import { useCompanyStore } from "../../store/company.store";
import { useCompany } from "../../hook/partner/company.partner.hook";
import { Modal, Tab, Tabs } from "react-bootstrap";
import { useOpportunitiesStore } from "../../store/opportunities.store";
import { useOpportunitiesCompanyDetail } from "../../hook/partner/opportunities.partner.hook";
import { useInvoicesStore } from "../../store/invoices.store";
import { useInvoicesCompanyDetail } from "../../hook/partner/invoices.partner.hook";
import { useRenewalsByCustomer } from "../../hook/partner/renewals.partner.hook";
import { useRenewalsStore } from "../../store/renewals.store";
import { NavLink } from "react-router";
import number_format from "../../utils/number_format";
import InvoiceDetailModal from "../modals/invoice/InvoiceDetailModal";
import RenewalOfferModal from "../modals/renewal/RenewalOfferModal";
import { useSoldSNStore } from "../..//store/soldsn.store";
import { useSNList } from "../../hook/partner/soldsnlist.partner.hook";
import { useLoansStore } from "../../store/loans.store";
import { useLoansCompanyDetail } from "../../hook/partner/loans.partner.hook";
import BusinessStats from "../../pages/BusinessStats";
import { useTranslation } from "../../hooks/useTranslation";

function CompanyDetail({ company_id, isModal, setTitle }) {
  const { t } = useTranslation();
  const companyMutation = useCompany();

  const setBreadcrumbs = useBreadcrumbsStore((state) => state.setBreadcrumbs);
  const setPagename = useBreadcrumbsStore((state) => state.setPagename);

  const token = useAuthStore((state) => state.token);
  const company = useCompanyStore((state) => state.company);

  const opportunitiesMutation = useOpportunitiesCompanyDetail();
  const opportunities = useOpportunitiesStore(
    (state) => state.opportunitiesCompanyDetail
  );

  const invoicesMutation = useInvoicesCompanyDetail();
  const invoices = useInvoicesStore((state) => state.invoicesCompanyDetail);

  const renewalsMutation = useRenewalsByCustomer();
  const renewals = useRenewalsStore((state) => state.renewalsByCustomer);
  const [openDetail, setOpenDetail] = useState(0);
  const [showRenewalModal, setShowRenewalModal] = useState(false);

  const snlistMutation = useSNList();
  const snList = useSoldSNStore((state) => state.snList);
  const [showSN, setShowSN] = useState();

  const loansMutation = useLoansCompanyDetail();
  const loans = useLoansStore((state) => state.loansCompanyDetail);

  const [oppPage, setOppPage] = useState(1);
  const [invPage, setInvPage] = useState(1);
  const [loanPage, setLoanPage] = useState(1);
  const [showInvoiceModal, setShowInvoiceModal] = useState(false);
  const [invoiceToShow, setInvoiceToShow] = useState(null);

  useEffect(() => {
    if (token) {
      companyMutation.mutate({ token, company_id });
    }
  }, [token]);

  useEffect(() => {
    if (company?.name) {
      if (isModal) {
        setTitle(company.name);
      } else {
        setPagename(company.name);
        setBreadcrumbs([{ name: t("company.clients"), link: "/klienti" }]);
      }
    } else {
      if (setTitle) {
        setTitle(t("company.clientDetail"));
      }
    }
    renewalsMutation.mutate({ company_id, token });
    snlistMutation.mutate({ token, company_id, letter: null });
  }, [company]);

  useEffect(() => {
    if (company?.company_id) {
      if (token) {
        opportunitiesMutation.mutate({
          token,
          page: oppPage,
          filter: { company_id },
          sortTable: "opportunity_id desc",
        });
      }
    }
  }, [company, oppPage]);

  useEffect(() => {
    if (company?.company_id) {
      if (token) {
        invoicesMutation.mutate({
          token,
          page: invPage,
          filter: { company_id },
          sortTable: "invoice_id desc",
        });
      }
    }
  }, [company, invPage]);

  useEffect(() => {
    if (token) {
      loansMutation.mutate({
        token,
        page: loanPage,
        data: {
          filter: { company_id },
        },
      });
    }
  }, [token, loanPage]);

  if (companyMutation.isLoading) {
    return <div className="alert alert-primary">{t("common.loading")}...</div>;
  }

  const pages = (page, pages, setFunc) => {
    if (pages > 1) {
      let buttons = [];
      for (let i = 1; i <= pages; i++) {
        buttons.push(
          <button
            onClick={() => eval(setFunc + "(" + i + ");")}
            key={i}
            className={
              "btn me-3 mb-3 btn-" + (i === page ? "primary" : "secondary")
            }
          >
            {i}
          </button>
        );
      }
      return <div className="mt-3">{buttons}</div>;
    }
  };
  const oppsTable = (opps) => {
    return (
      <>
        {opps && opps.data && opps.data.length > 0 ? (
          <>
            <p>
              <strong>{t("common.found")}:</strong> {opps.rows} {t("common.records")}
            </p>
            <div style={{ overflow: "auto" }}>
              <table className="table align-middle table-row-dashed fs-6 gy-5 dataTable">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>{t("common.description")}</th>
                    <th>{t("opportunities.dateCreated")}</th>
                    <th>{t("common.state")}</th>
                    <th>{t("opportunities.dealVolume")}</th>
                    <th>{t("opportunities.salesperson")}</th>
                  </tr>
                </thead>
                <tbody>
                  {opps.data.map((opportunity) => (
                    <tr key={opportunity.opportunity_id}>
                      <td>
                        <NavLink
                          to={"/prilezitost/" + opportunity.opportunity_id}
                        >
                          {opportunity.opportunity_id}
                        </NavLink>
                      </td>
                      <td>
                        {opportunity.description}
                        <div>
                          {opportunity.vendors?.map((vendor) => (
                            <badge
                              className={
                                "badge badge-secondary me-3 badge-vendor-" +
                                vendor.vendor_id
                              }
                            >
                              {vendor.name}
                            </badge>
                          ))}
                        </div>
                      </td>
                      <td>
                        {new Date(opportunity.create_date).toLocaleDateString()}
                      </td>
                      <td>{opportunity.current_state.state_name}</td>
                      <td className="text-end">
                        {number_format(
                          opportunity.purchase_total_amount_local_currency,
                          2,
                          ",",
                          "."
                        ) +
                          " " +
                          opportunity.local_currency}
                      </td>
                      <td>
                        {opportunity.exn_person?.first_name}{" "}
                        {opportunity.exn_person?.last_name}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            {pages(oppPage, opportunities.total_pages, "setOppPage")}
          </>
        ) : (
          <div className="alert alert-warning">{t("common.nothingFound")}...</div>
        )}
      </>
    );
  };

  const loanTab = (loans) => {
    return (
      <>
        {loans && loans.data && loans.data.length > 0 ? (
          <>
            <p>
              <strong>{t("common.found")}:</strong> {loans.rows} {t("common.records")}
            </p>
            <div style={{ overflow: "auto" }}>
              <table className="table align-middle table-row-dashed fs-6 gy-5 dataTable">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>{t("opportunities.dateCreated")}</th>
                    <th>{t("loans.loanStart")}</th>
                    <th>{t("loans.loanEnd")}</th>
                    <th>{t("common.state")}</th>
                  </tr>
                </thead>
                <tbody>
                  {loans.data.map((loan) => (
                    <tr key={loan.loan_id}>
                      <td>
                        <NavLink to={"/zapujcka/" + loan.loan_id}>
                          {loan.loan_id}
                        </NavLink>
                      </td>
                      <td>{new Date(loan.create_date).toLocaleDateString()}</td>
                      <td>{new Date(loan.loan_from).toLocaleDateString()}</td>
                      <td>{new Date(loan.loan_to).toLocaleDateString()}</td>
                      <td>
                        <span
                          className={
                            "badge badge-" + loan.current_state.state_style
                          }
                        >
                          {loan.current_state.state_name}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            {pages(loanPage, loans.total_pages, "setLoanPage")}
          </>
        ) : (
          <div className="alert alert-warning">{t("common.nothingFound")}...</div>
        )}
      </>
    );
  };

  const invTable = (invoices) => {
    return (
      <>
        {invoices && invoices.data && invoices.data.length > 0 ? (
          <>
            <InvoiceDetailModal
              invoice_id={invoiceToShow}
              show={showInvoiceModal}
              handleClose={() => setShowInvoiceModal(false)}
              token={token}
            />
            <p>
              <strong>{t("common.found")}:</strong> {invoices.rows} {t("common.records")}
            </p>
            <div style={{ overflow: "auto" }}>
              <table className="table align-middle table-row-dashed fs-6 gy-5 dataTable">
                <thead>
                  <tr>
                    <th>{t("invoices.document")}</th>
                    <th>{t("common.description")}</th>
                    <th>{t("soldSn.opportunity")}</th>
                    <th>{t("opportunities.dateCreated")}</th>
                    <th>{t("invoices.duzp")}</th>
                    <th>{t("invoices.dueDate")}</th>
                    <th>{t("common.state")}</th>
                    <th>{t("invoices.totalToPay")}</th>
                  </tr>
                </thead>
                <tbody>
                  {invoices.data.map((invoice) => (
                    <tr key={invoice.invoice_id}>
                      <td>
                        <a
                          href="javascript:;"
                          onClick={() => {
                            setShowInvoiceModal(true);
                            setInvoiceToShow(invoice.invoice_id);
                          }}
                        >
                          {invoice.invoice_number}
                        </a>
                      </td>
                      <td>{invoice.description}</td>
                      <td>
                        <NavLink to={"/prilezitost/" + invoice.opportunity_id}>
                          {invoice.opportunity_id}
                        </NavLink>
                      </td>
                      <td>
                        {new Date(invoice.invoice_date).toLocaleDateString()}
                      </td>
                      <td>
                        {new Date(
                          invoice.invoice_tax_date
                        ).toLocaleDateString()}
                      </td>
                      <td>
                        {new Date(
                          invoice.invoice_due_date
                        ).toLocaleDateString()}
                      </td>
                      <td>
                        <span
                          className={
                            "badge badge-" + invoice.status?.status_style
                          }
                        >
                          {invoice.status?.status_description}
                        </span>
                      </td>
                      <td className="text-end">
                        {number_format(
                          invoice.total_amount_currency,
                          2,
                          ",",
                          "."
                        ) +
                          " " +
                          invoice.invoice_currency}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            {pages(invPage, invoices.total_pages, "setInvPage")}
          </>
        ) : (
          <div className="alert alert-warning">{t("common.nothingFound")}...</div>
        )}
      </>
    );
  };

  const renewalsTab = (renewals) => {
    return renewals && renewals.length > 0 ? (
      <>
        <RenewalOfferModal
          show={showRenewalModal}
          handleClose={() => setShowRenewalModal(false)}
          renewal={openDetail}
          title={openDetail?.vendor}
        />
        <div className="row">
          {renewals.map((renewal) => (
            <div className="col-md-4">
              <div className="card mb-4">
                <div className="card-header">
                  <h3 className="card-title">
                    {new Date(renewal.expire_date).toLocaleDateString()}
                    <span className="ms-4 badge badge-info badge-outline">
                      {renewal.vendor}
                    </span>
                  </h3>
                </div>
                <div className="card-body">
                  <div className="row">
                    <div className="col-12 mb-3">
                      <strong>{t("common.total")}</strong>
                      <div>{renewal.quantity}</div>
                    </div>
                    <div className="col-6 mb-3">
                      <strong>{t("renewals.inProgress")}</strong>
                      <div>
                        {renewal.quantity_renewal == 0 ? (
                          <span class="badge badge-primary">
                            {renewal.quantity_renewal}
                          </span>
                        ) : (
                          renewal.quantity_renewal
                        )}
                      </div>
                    </div>
                    <div className="col-6 mb-3">
                      <strong>{t("renewals.renewing")}</strong>
                      <div>
                        {renewal.quantity_renewal_progress > 0 ? (
                          <span class="badge badge-warning">
                            {renewal.quantity_renewal_progress}
                          </span>
                        ) : (
                          renewal.quantity_renewal_progress
                        )}
                      </div>
                    </div>
                    <div className="col-6 mb-3">
                      <strong>{t("renewals.renewed")}</strong>
                      <div>
                        {renewal.quantity_renewal_done > 0 ? (
                          <span class="badge badge-success">
                            {renewal.quantity_renewal_done}
                          </span>
                        ) : (
                          renewal.quantity_renewal_done
                        )}
                      </div>
                    </div>
                    <div className="col-6 mb-3">
                      <strong>{t("renewals.withoutRenewal")}</strong>
                      <div>
                        {renewal.quantity_renewal_lost > 0 ? (
                          <span class="badge badge-secondary">
                            {renewal.quantity_renewal_lost}
                          </span>
                        ) : (
                          renewal.quantity_renewal_lost
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card-footer">
                  <button
                    className="btn btn-primary btn-sm w-100"
                    onClick={() => {
                      setShowRenewalModal(true);
                      setOpenDetail({
                        ...renewal,
                        company_id,
                      });
                    }}
                  >
                    {t("common.detail")}
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </>
    ) : (
      <div className="alert alert-warning">{t("common.nothingFound")}...</div>
    );
  };

  const fullName = (prod) => {
    return (
      <>
        {prod.product.product_family + ": " + prod.product.name}{" "}
        <span
          className={
            "badge badge-secondary me-3 mb-3 badge-vendor-" +
            prod.product.vendor_id
          }
        >
          {prod.product.vendor_name}
        </span>
        <span className="badge badge-info badge-outline">
          {prod.product.sku}
        </span>
      </>
    );
  };

  const snTab = () => {
    return (
      <>
        <Modal show={showSN} onHide={() => setShowSN(false)}>
          <Modal.Header closeButton>{t("common.detail")} {showSN?.sn}</Modal.Header>
          <Modal.Body>
            {showSN?.opportunity_list && (
              <span
                className={
                  "badge badge-secondary badge-vendor-" +
                  showSN?.opportunity_list[0]?.product.vendor_id
                }
              >
                {showSN?.opportunity_list[0]?.product.vendor_name}
              </span>
            )}
            {showSN?.opportunity_list && (
              <table className="table align-middle table-row-dashed fs-6 gy-5 dataTable">
                <thead>
                  <tr>
                    <th>{t("soldSn.opportunity")}</th>
                    <th>{t("opportunities.product")}</th>
                    <th>{t("common.expiration")}</th>
                  </tr>
                </thead>
                <tbody>
                  {showSN.opportunity_list.map((op) => (
                    <tr key={op.opportunity_id}>
                      <td>
                        <NavLink to={"/prilezitost/" + op.opportunity_id}>
                          {op.opportunity_id}
                        </NavLink>
                      </td>
                      <td>
                        {op.product.product_family}, {op.product.name}
                      </td>
                      <td>
                        {op.expiration_date !== "0000-00-00"
                          ? new Date(op.expiration_date).toLocaleDateString()
                          : "n/a"}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </Modal.Body>
        </Modal>
        <div className="row">
          {snList && snList.length > 0 ? (
            snList?.map((sn) => (
              <div className="col-md-4 col-lg-3 my-3">
                <div className="card h-100" key={sn}>
                  <div className="card-header">
                    <h3 className="card-title">{sn.sn}</h3>
                  </div>
                  <div className="card-body">
                    {fullName(
                      sn.opportunity_list.find(
                        (snl) => snl.opportunity_id === sn.first_opportunity_id
                      )
                    )}
                  </div>
                  <div className="card-footer">
                    <button
                      className="btn btn-primary btn-sm w-100"
                      onClick={() => setShowSN(sn)}
                    >
                      {t("common.detail")}
                    </button>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="alert alert-warning">{t("common.nothingFound")}...</div>
          )}
        </div>
      </>
    );
  };

  return (
    <>
      {company && (
        <>
          <div className="row">
            <div className="col-md-4">
              {company.street}
              <br />
              {company.zip} {company.city}
            </div>
            <div className="col-md-4">
              <strong>{t("company.companyId")}:</strong> {company.ic}
              <br />
              <strong>{t("company.taxId")}:</strong> {company.dic}
            </div>
            <div className="col-md-4">
              {company.bank_accounts?.map((ba) => (
                <div className="row mb-4">
                  <div className="col-6">
                    <strong>{ba.bank}</strong>
                    <br />
                    {ba.account_number}/{ba.account_code}
                  </div>
                  <div className="col-6">
                    <strong>SWIFT:</strong> {ba.swift}
                    <br />
                    <strong>IBAN:</strong> {ba.iban}
                  </div>
                </div>
              ))}
            </div>
          </div>
          <Tabs
            defaultActiveKey={0}
            className="nav-strech nav-line-tabs border-transparent fs-5 fw-bold nav-line-tabs-2x mt-4"
          >
            <Tab title={t("navigation.opportunities")} key={0} eventKey={0}>
              <Tab.Content className="pt-5 border-top">
                {opportunitiesMutation.isLoading ? (
                  t("common.loading") + "..."
                ) : (
                  <>{oppsTable(opportunities)}</>
                )}
              </Tab.Content>
            </Tab>
            <Tab title={t("navigation.invoices")} key={1} eventKey={1}>
              <Tab.Content className="pt-5 border-top">
                {invoicesMutation.isLoading ? (
                  t("common.loading") + "..."
                ) : (
                  <>{invTable(invoices)}</>
                )}
              </Tab.Content>
            </Tab>
            <Tab title={t("navigation.renewals")} key={2} eventKey={2}>
              <Tab.Content className="pt-5 border-top">
                {renewalsMutation.isLoading
                  ? t("common.loading") + "..."
                  : renewalsTab(renewals)}
              </Tab.Content>
            </Tab>
            <Tab title={t("navigation.soldSn")} key={3} eventKey={3}>
              <Tab.Content className="pt-5 border-top">
                {snlistMutation.isLoading ? t("common.loading") + "..." : snTab(snList)}
              </Tab.Content>
            </Tab>
            <Tab title={t("navigation.loans")} key={4} eventKey={4}>
              <Tab.Content className="pt-5 border-top">
                {loansMutation.isLoading ? t("common.loading") + "..." : loanTab(loans)}
              </Tab.Content>
            </Tab>
            <Tab title={t("company.statistics")} key={5} eventKey={5}>
              <Tab.Content className="pt-5 border-top">
                <BusinessStats company_id={company_id} />
              </Tab.Content>
            </Tab>
          </Tabs>
        </>
      )}
    </>
  );
}

export default CompanyDetail;
